

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Companies from './components/Companies';
import FormPage from './components/FormPage';
import Header from './components/Header';
import ForgotPassword from './components/ForgotPassword';
import Submissions from './components/Submissions';
import VerificationPage from './components/VerificationPage';
import JoinChat from './components/JoinChat';

import Auth from './components/Auth';

function App() {
  return (
    <>
    <Header />
    <Routes>
    <Route path="/" element={<Auth />} />
      <Route path="/companies" element={<Companies />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/form/:slug" element={<FormPage />} />
      <Route path="/subs" element={<Submissions />} />
      <Route path="/verify/:referenceNumber" element={<VerificationPage />} />

    </Routes>

    <JoinChat /> 
    </>
  );
}

export default App;

